import { useEffect, useRef, useState } from 'react';
import { Post } from './Post';

// アプリの「ロッカーを開ける」（2026-10-22）。タッチパネルが動かないときに、番号を入れずにロッカーを遠隔で開ける。
// 開ける用QRを有効にした拠点だけ（注文の locker_remote_open=1 のときに出す）。
// 確認は画面の中で出す（iPhone のアプリ内ブラウザでは標準の confirm() が出ないことがある）。
// 押したあとは2秒ごとに結果を確かめる。端末が拾わなければ約2分で取りやめになる。
const POLL_MS = 2000;
const POLL_MAX = 65; // 約130秒

export default function LockerRemoteOpen({ order }) {
  const [stage, setStage] = useState('idle'); // idle | confirm | sending | waiting | done | failed
  const [message, setMessage] = useState('');
  const [boxName, setBoxName] = useState('');
  const timer = useRef(null);
  const alive = useRef(true);

  useEffect(() => () => { alive.current = false; clearTimeout(timer.current); }, []);

  if (Number(order?.locker_remote_open) !== 1) return null;

  function poll(commandId, n) {
    timer.current = setTimeout(async () => {
      const r = await Post('post', '/order/locker_open_status.php', { command_id: commandId });
      if (!alive.current) return;
      if (r.result === 1 && r.status === 'done') { setStage('done'); return; }
      if (r.result === 1 && ['failed', 'expired', 'superseded'].includes(r.status)) {
        setStage('failed');
        setMessage('ロッカーが開きませんでした。もう一度押すと、別のボックスで開けることがあります。');
        return;
      }
      if (n + 1 >= POLL_MAX) {
        setStage('failed');
        setMessage('ロッカーから返事がありません。少し待ってからもう一度お試しください。');
        return;
      }
      poll(commandId, n + 1);
    }, POLL_MS);
  }

  async function open() {
    setStage('sending');
    setMessage('');
    const r = await Post('post', '/order/locker_open.php', { order_id: order.id });
    if (!alive.current) return;
    if (r.result !== 1) {
      setStage('failed');
      setMessage(r.error_message || '開けられませんでした。');
      return;
    }
    setBoxName(r.box_name || '');
    setStage('waiting');
    poll(r.command_id, 0);
  }

  const box = boxName ? `${boxName}番のボックス` : 'ボックス';
  return (
    <div className="content" style={{ marginTop: 8 }}>
      <div style={{ fontSize: 13, color: 'var(--ink)', marginBottom: 8 }}>
        タッチパネルが動かないときは、ここから開けられます。<b>必ずロッカーの前で押してください。</b>
      </div>
      {stage === 'idle' && (
        <button type="button" className="btn btn-outline-primary w-100" onClick={() => setStage('confirm')}>
          ロッカーを開ける
        </button>
      )}
      {stage === 'confirm' && (
        <div>
          <div className="mb-2" style={{ fontWeight: 700 }}>いまロッカーの前にいますか？押すとすぐにロッカーが開きます。</div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button type="button" className="btn btn-primary" style={{ flex: 1 }} onClick={open}>開ける</button>
            <button type="button" className="btn btn-outline-secondary" style={{ flex: 1 }} onClick={() => setStage('idle')}>やめる</button>
          </div>
        </div>
      )}
      {(stage === 'sending' || stage === 'waiting') && (
        <div style={{ fontWeight: 700 }}>
          {stage === 'sending' ? 'ロッカーに伝えています…' : `${box}を開けています…（20秒ほどかかることがあります）`}
        </div>
      )}
      {stage === 'done' && (
        <div className="text-success" style={{ fontWeight: 700 }}>
          {box}が開きました。{Number(order.otype) === 1 ? 'お預けのあと、扉を閉めてから下の「お預け完了」を押してください。' : 'お品物を取り出し、扉を閉めてから受け取り完了のボタンを押してください。'}
        </div>
      )}
      {stage === 'failed' && (
        <div>
          <div className="text-danger mb-2">{message}</div>
          <button type="button" className="btn btn-outline-primary w-100" onClick={() => setStage('confirm')}>もう一度開ける</button>
        </div>
      )}
    </div>
  );
}
